export default {
    // Config like options here
};
